module.exports = __webpack_public_path__ + "static/media/ccny-logo-reverse-clip.af7cda48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ccny-logo-reverse-clip.svg
// module id = 550
// module chunks = 3